export enum SubscriptionPlanType {
  ADD_ON = "ADD_ON",
  BASE = "BASE",
  USAGE_BASED = "USAGE_BASED"
}
